import { createFileRoute } from "@tanstack/react-router";
import { type FC, useEffect } from "react";
import { FullScreenLoading } from "../../../../components/molecules/FullScreenLoading";

const RouteComponent: FC = () => {
  useEffect(() => {
    window.location.reload();
  }, []);

  return <FullScreenLoading />;
};

export const Route = createFileRoute(
  "/_private/vbuyer/helps/invoice_and_payment_procedures",
)({
  component: RouteComponent,
});
